export default "__VITE_ASSET__8d0cf5ea__"